import GridComponent from "../../../component/grid/GridComponent.component";
import Graphic from "./component/Graphic.component";
import Rankings from "./component/Rankings.component";
import Details from "../operationalIndicator/Details.component";
import { useEffect, useState } from "react";
import { getAssesments } from "../../store/details/Details.service";
import { AssesmentInterface } from "../../store/details/assessment/interface/AssesmentInterface";
import Progresse from "../../../component/progress/Progress.component";
import { ListofMonsths } from "../utils/ListOfMonths";

/*
const data = [
    { name: "Jan", NPS: Math.floor(Math.random() * 100) },
    { name: "Fev", NPS: Math.floor(Math.random() * 100) },
    { name: "Mar", NPS: Math.floor(Math.random() * 100) },
    { name: "Abr", NPS: Math.floor(Math.random() * 100) },
    { name: "Mai", NPS: Math.floor(Math.random() * 100) },
    { name: "Jun", NPS: Math.floor(Math.random() * 100) }
]; */

interface propsGrafic {
  name: string;
  NPS: number;
}

export default function MyStore() {

    const [assessments, setAssessments] = useState<AssesmentInterface[]>([])
    const [request, setRequest] = useState<boolean>(true);
    const [listNPSLastMonsths, setListNPSLastMonsths] = useState<propsGrafic[]>([]);
    const [npsCurrentMonth, setNpsCurrentMonth] = useState<number>(0);
    
    function lastMonth(date: Date, diff: number) {
      const d = new Date(date);
      d.setMonth(d.getMonth() + diff);
      return d;
    }
    
    function lastSixMonths(data: Date) {
      const datas = [];
      datas.push(data);
      for (let i = 1; i < 7; i++) {
        datas.push(lastMonth(data, i * -1));
      }
      return datas;
    }

    function getNPSCalc() {

        let date = new Date();
        let nowMonth = date.getMonth() + 1;
        let nowYear = date.getFullYear();

        let qtdPromotor = 0;
        let qtdNeutro = 0;
        let qtdDetrator = 0;

        let AvaliacoesDoMes = assessments.filter((item) => {
            let monthAndYear = formatDate(item.createdAt.toString(), true);
              if (monthAndYear[0] === nowMonth && monthAndYear[1] === nowYear) {
                  return true;
              }
            return false;
        });

        AvaliacoesDoMes.forEach((item) => {
          if (item.vlrPerguntaNPS > 8) {
              qtdPromotor++;
          }
          if (item.vlrPerguntaNPS === 7 || item.vlrPerguntaNPS === 8) {
              qtdNeutro++;
          }
          if (item.vlrPerguntaNPS < 7) {
              qtdDetrator++;
          }
        })

        let percPromotor = Math.floor((qtdPromotor / AvaliacoesDoMes.length ) * 100);
        let percDetrator = Math.floor((qtdDetrator / AvaliacoesDoMes.length) * 100);
        //let percNeutro = Math.floor((qtdNeutro / AvaliacoesDoMes.length) * 100);

        setNpsCurrentMonth(percPromotor - percDetrator);

    }

    function getNPSCalcLastMonths() {

      let date = new Date();

      let qtdPromotor = 0;
      let qtdNeutro = 0;
      let qtdDetrator = 0;

      const lastMonsths = lastSixMonths(date);

      let listMonths: number[] = [];
      let listNPS: number[] = [];
      let mediaNPS = 0;

      const listEvaluations = assessments.filter(item => item.id);

      if (listEvaluations.length !== 0) {
        lastMonsths.forEach((item) => {

          let AvaliacoesDoMesAnterior = [];

          let monthAndYear = formatDate(item.toString(), false);

          AvaliacoesDoMesAnterior = listEvaluations.filter((assessement) => {
            let monthAndYearAssessment = formatDate(assessement.createdAt.toString(), true);
              if (monthAndYear[0] === monthAndYearAssessment[0] && monthAndYear[1] === monthAndYearAssessment[1]) {
                  return true;
              }
            return false;
          });

          if (AvaliacoesDoMesAnterior.length !== 0) {

            AvaliacoesDoMesAnterior.forEach((assessment) => {
              if (assessment.vlrPerguntaNPS > 8) {
                  qtdPromotor++;
              }
              if (assessment.vlrPerguntaNPS === 7 || assessment.vlrPerguntaNPS === 8) {
                  qtdNeutro++;
              }
              if (assessment.vlrPerguntaNPS < 7) {
                  qtdDetrator++;
              }
            })
          }

          let npsDoMes = 0;
          let changedNPS = false;

          if (AvaliacoesDoMesAnterior.length !== 0) {
            let percPromotor = Math.floor((qtdPromotor / AvaliacoesDoMesAnterior.length ) * 100);
            let percDetrator = Math.floor((qtdDetrator / AvaliacoesDoMesAnterior.length) * 100);
            //let percNeutro = Math.floor((qtdNeutro / AvaliacoesDoMes.length) * 100);
            npsDoMes = percPromotor - percDetrator;

            mediaNPS = mediaNPS + npsDoMes;
            changedNPS = true;
          }

          listMonths.push(monthAndYear[0]);

          if (changedNPS) {
            listNPS.push(npsDoMes);
          } 
          
          qtdPromotor = 0;
          qtdDetrator = 0;
          qtdNeutro = 0;
        })
      }

      let listMonthAndValue: propsGrafic[] = [];

      for (let i = 0; i < listMonths.length; i++) {
        let nameMonth = "";
        ListofMonsths.forEach((item) => {
          if (item.index === listMonths[i]) {
            nameMonth = item.name;
          }
        })
        let value = listNPS[i];

        listMonthAndValue.push({name: nameMonth, NPS: value});
        
      }
      listMonthAndValue.reverse();
      setListNPSLastMonsths(listMonthAndValue); 
    }

    function getAnsweredReviews(): number {
      const evaluations = assessments.filter(item => item.flAvaliadoLoja);
      return evaluations.length;
    }

    function formatDate(date: string, currentMonth?: boolean): [number, number] {

      let year;
      let month;

      if (currentMonth === false) {
        let data = new Date(date);
        year = data.getFullYear();
        month = data.getMonth() + 1;
      } else {
        let data = date.substring(0, 10);
        year = data.substring(0, 4);
        month = data.substring(5, 7);
      }
      return [Number(month), Number(year)]
    }

    useEffect(() => {
      getAssessments();
      getNPSCalc();
      getNPSCalcLastMonths();      
      
    }, [request])

    async function getAssessments() {
      setTimeout(async () => {
        await getAssesments().then(res => {
          setAssessments(res.data);
        }).catch((error) => {
          console.log("Erro ao consultar avaliações", error)
        }).finally(() => {
          setRequest(false);
        })
      }, 1000*1.5)
    }

    return (
      <>
        <Details />
        
        <GridComponent alignItems={"flex-start"} justify={"space-between"}>
          {!request ? 
          <>
          <Graphic data={listNPSLastMonsths} title='Histórico NPS Funcionários' />
          <Rankings title='NPS Funcionários' valueNPS={npsCurrentMonth} qtdAssessments={assessments.length} answeredRatings={getAnsweredReviews()} />
          </>
          : <Progresse open={request} />} 
        </GridComponent>
        {/*<GridComponent alignItems={"flex-start"} justify={"space-between"} >
          <Graphic data={data2} title='Histórico NPS Clientes' value={dataValue2Result} />
          <Rankings title='Rankings NPS Clientes' />
        </GridComponent > */}
      </>
    );
  }
  
